import * as React from 'react';

import {Col, Row, Icon, notification} from 'antd';

import './SignIn.css';

import logo from '../../images/nurate-logo.png';
import SignInForm from './SignInForm';


class SignIn extends React.Component<{}, {}> {

  constructor(props: {}) {
    super(props);
    this.state = {
      email: '',
      errorMessage: ''
    }

  }

  componentDidMount(): void {
    // notification.open({
    //   message: 'New Release',
    //   description: 'We are currently releasing new version, site might be unstable. Sorry for inconveniences',
    // });
  }

  public render() {

    return(
      <div className='signin'>
        <Row type='flex' justify='center'>
          <Col span={10}>
            <Row type='flex' justify='center'>
              <img src={logo} />
            </Row>
            <Row type='flex' justify='center'>
              <Col span={16}>
                <br/>
                <p className='greeting-text'>
                  Welcome to Nurate, closed university social platform
                </p>
              </Col>
            </Row>

            <br/><br/>
            <Row type='flex' justify='center'>
              <Col span={16}>

                <div className='features-list-item'>
                  <div className='features-list-item-icon'>
                    <Icon type="file" className='primary-light-color' />
                  </div>
                  <div className='features-list-item-text'>
                    <span>Share materials</span>
                  </div>
                </div>

                <div className='features-list-item'>
                  <div className='features-list-item-icon'>
                    <Icon type="sound" className='primary-light-color' />
                  </div>
                  <div className='features-list-item-text'>
                    <span>Leave feedbacks for courses</span>
                  </div>
                </div>

                <div className='features-list-item'>
                  <div className='features-list-item-icon'>
                    <Icon type='wechat' className='primary-light-color' />
                  </div>
                  <div className='features-list-item-text'>
                    <span>Chat with course-mates</span>
                  </div>
                </div>

              </Col>
            </Row>
          </Col>

          <Col span={8}>
            <Row type='flex' justify='center' align='middle' className='signin-form'>
              <SignInForm />
            </Row>
          </Col>

        </Row>
      </div>
    )
  }

}

export default SignIn;

